import type * as React from "react";
import { Button } from "~/components/ui/button";
import { LoadingIndicator } from "~/components/ui/loading-indicator";

function ButtonLoading({
	children,
	isLoading = false,
	replace = false,
	...props
}: React.ComponentProps<typeof Button> & {
	isLoading?: boolean;
	replace?: boolean;
}) {
	return (
		<Button {...props}>
			{isLoading && <LoadingIndicator />}
			{replace && isLoading ? null : children}
		</Button>
	);
}

export { ButtonLoading };
